import React from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { formatLabel } from "../../Utils/walletFormat";

const TXN_TYPES = [
  "recharge",
  "debit",
  "refund",
  "manual_credit",
  "manual_debit",
];

const LEDGER_TYPES = [
  "balance_credit",
  "balance_debit",
  "credit_used_increase",
  "credit_used_decrease",
];

const STATUSES = ["pending", "completed", "failed", "reversed"];

/**
 * Compact filter row for ledger / transactions lists.
 * @param {'transactions'|'ledger'} variant
 */
export default function WalletListFilters({
  variant = "transactions",
  value,
  onChange,
  onApply,
  onClear,
}) {
  const typeOptions = variant === "ledger" ? LEDGER_TYPES : TXN_TYPES;
  const typeLabel = variant === "ledger" ? "Entry type" : "Type";

  const set = (key, next) => onChange({ ...value, [key]: next });

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={1.5}
      alignItems={{ md: "center" }}
      flexWrap="wrap"
      useFlexGap
    >
      <TextField
        size="small"
        type="date"
        label="From"
        InputLabelProps={{ shrink: true }}
        value={value.from || ""}
        onChange={(e) => set("from", e.target.value)}
        sx={{ minWidth: 150 }}
      />
      <TextField
        size="small"
        type="date"
        label="To"
        InputLabelProps={{ shrink: true }}
        value={value.to || ""}
        onChange={(e) => set("to", e.target.value)}
        sx={{ minWidth: 150 }}
      />
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>{typeLabel}</InputLabel>
        <Select
          label={typeLabel}
          value={value.type || ""}
          onChange={(e) => set("type", e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {typeOptions.map((t) => (
            <MenuItem key={t} value={t}>
              {formatLabel(t)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>Status</InputLabel>
        <Select
          label="Status"
          value={value.status || ""}
          onChange={(e) => set("status", e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          {STATUSES.map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Stack direction="row" spacing={1}>
        <Button variant="contained" size="small" onClick={onApply}>
          Apply
        </Button>
        <Button variant="outlined" size="small" onClick={onClear}>
          Clear
        </Button>
      </Stack>
    </Stack>
  );
}

export const EMPTY_LIST_FILTERS = {
  from: "",
  to: "",
  type: "",
  status: "",
};
